import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *  https://vue-multiselect.js.org/
 */

import { SIcon } from '@strana-artw/ui-kit';
import Multiselect from 'vue-multiselect';
export default {
  name: 'CSelect',
  components: {
    Multiselect: Multiselect,
    SIcon: SIcon
  },
  props: {
    label: {
      type: String,
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    empty: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [Object, String, Array],
      default: undefined
    },
    searchable: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Function,
      default: function _default(option) {
        return option.selectable !== false;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bind: function bind() {
      var _this$placeholder;
      return _objectSpread({
        placeholder: (_this$placeholder = this.placeholder) !== null && _this$placeholder !== void 0 ? _this$placeholder : '',
        selectLabel: '',
        selectGroupLabel: '',
        selectedLabel: '',
        deselectLabel: '',
        deselectGroupLabel: '',
        allowEmpty: false,
        searchable: this.searchable,
        options: this.options,
        value: this.value
      }, this.$attrs);
    },
    classes: function classes() {
      return _defineProperty({}, this.$style.disabled, this.disabled);
    }
  },
  methods: {
    changeValue: function changeValue(event) {
      this.$emit('input', event);
    },
    active: function active(item) {
      return item.value;
    }
  }
};